import { Experiments } from 'core/type/BootstrapConfig.types';
import { ExperimentId } from 'core/type/ExperimentId';
import { getBootstrapConfig } from 'core/window/windowService';
import { FeatureName } from 'core/constant/FeatureName';

export const OppositeTextDirection: Record<string, string> = {
    rtl: 'ltr',
    ltr: 'rtl',
};

export const getRootUrl = (config = getBootstrapConfig()) => {
    return config.rootUrl || '';
};

export const getSessionId = (config = getBootstrapConfig()) => {
    return config.sessionId || '';
};

export const isProdEnv = (config = getBootstrapConfig()) => {
    return config.feMessagingConfig.environment === 'prod';
};

export const getIsMockData = (config = getBootstrapConfig()) => {
    return config.isMockData;
};

/**
 * isB for experiment without BM
 * Please using <b>'useExperimentIsB'</b> hook instead in a React component.<br/>
 * Please use this function in mappers, reducers, or any non-React components.
 */
export const isB = (experimentId: ExperimentId, experiments: Experiments): boolean => {
    // noinspection PointlessBooleanExpressionJS This check is not pointless, I wanted to avoid double negation !!
    return experiments && experiments[experimentId] === true;
};

/**
 * isOn for behavior experiments
 * Please prefer using <b>'useFeatureEnabled'</b> hook instead in a React component.<br/>
 * Please use 'isOn' in mappers, reducers, or any non-React components.
 */
export const isOn = (featureName: FeatureName, config = getBootstrapConfig()): boolean => {
    return config.behavior?.featureExperiments?.featureBehavior && config.behavior.featureExperiments.featureBehavior[featureName];
};

export const isAnyB = (experiments: Experiments, experimentId: ExperimentId | ExperimentId[]): boolean => {
    if (!experiments) return false;
    if (Array.isArray(experimentId)) {
        return experimentId.some((expId) => isB(expId, experiments));
    }
    return isB(experimentId, experiments);
};

export const isAllB = (experiments: Experiments, experimentId: ExperimentId | ExperimentId[]): boolean => {
    if (!experiments) return false;
    if (Array.isArray(experimentId)) {
        return !experimentId.some((expId) => !isB(expId, experiments));
    }
    return isB(experimentId, experiments);
};

const isSupportedLanguageInternal = (supportedLanguages: string[], culture: string): boolean => {
    const cultureCode = culture.toLowerCase();
    if (supportedLanguages.includes(cultureCode)) {
        return true;
    }

    const langCode = `${cultureCode.split('-')[0]}-`;
    const firstMatch = supportedLanguages.find((languageLocale) => languageLocale.startsWith(langCode));
    return !!firstMatch;
};

export const isSupportedLanguage = (config = getBootstrapConfig()): boolean => {
    if (!config.supportedLocalization || !config.supportedLocalization.languages || config.supportedLocalization.languages.length === 0) {
        return true;
    }
    return isSupportedLanguageInternal(config.supportedLocalization.languages, config.language.cultureCode);
};
